import React, { useEffect } from "react";
import FlipCardSlider from "../../components/Slider/FlipCardSlider";
import ArticleContainer from "../../components/Article/ArticleContainer";
import ArticleHero from "../../components/Hero/ArticleHero";

const relatedBlogs = [
 
  {
    contentType: "BLOG",
    title: "Envisioning the Future of Mobility with Shoora",
    description:
      "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
    thumbnail:
      "/images/thumbnails/14.jpeg",
    link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
    readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Leverage AIS-140’s Mandate for Telematics Devices",
    description:
      "Shoora, a leader in advanced video telematics solutions , is committed to harnessing the potential of this mandate to create safer roads and smarter transportation systems.",
    thumbnail: "https://www.easyembedded.net/images/ais2.jpg",
    link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
    readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Tackling Distracted Driving: Transforming Fleet Safety",
    description:
      "By adopting the Three Ts—Talk, Train, and Track, Shoora addresses distracted driving head-on, protecting lives and optimising operations.",
    thumbnail: "/images/thumbnails/3.jpeg",
    link: "/insights/blog/tackling-distracted-driving-transforming-fleet-safety",
    readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
    description:
      "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
    thumbnail:
      "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
    link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
    readTime: 10,
  },
  {
    contentType: "CUSTOMER STORY",
    title: "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
    description:
      "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
    thumbnail:
      "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
    link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
    readTime: 10,
  },

  {
    contentType: "CUSTOMER STORY",
    title: "Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres",
    description:
      "The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.",
    thumbnail: "/images/thumbnails/15.jpeg",
    link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
    readTime: 10,
  },
];

const data = {
  contentType: "BLOG",
  title: "Complimenting Fleet Modernization with Road Safety",
  author: "Shoora",
  createdOn: "26th Oct, 2024",
  imgsrc:
    "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  readTime: 10,
  content: `<p>
                        Shoora is leading the charge in transforming fleet operations by enhancing safety and operational efficiency through the Voluntary Vehicle-Fleet Modernization Programme (VVMP). Shoora empowers fleet operators to embrace the VVMP, aligning with the Government of India's efforts to reduce pollution, enhance road and passenger safety, boost fuel efficiency, and lower vehicle maintenance costs.  <br /><br />

                        As a trailblazer in the telematics solutions industry, Shoora combines advanced technologies like AI, machine learning (ML), and the Internet of Things (IoT) to provide smarter, safer, and more sustainable solutions for fleet management.
                        <br /><br />
                        The VVMP aims to modernise vehicle fleets, optimising their performance while ensuring environmental sustainability. Shoora's cutting-edge products, such as FleetSense™, CabinAlerts™, and RoadSense™, provide fleet operators with real-time monitoring, instant alerts, and predictive analytics. These tools help reduce fuel consumption, enhance driver behaviour, and lower accident rates, making fleets more eco-friendly while improving overall safety.

                        <br /><br />
                        Shoora’s solutions, like advanced telematics and driver coaching through AI-powered dashboards, are not only focused on improving fleet efficiency but also on reducing emissions and operational costs. By incentivizing safe driving habits and offering real-time coaching, Shoora contributes to a reduction in vehicle-related accidents and ensures lower carbon footprints.
                        <br /><br />

                        With its commitment to safety, efficiency, and sustainability, Shoora is helping India’s fleet operators meet the goals of the VVMP, while simultaneously contributing to a safer, greener future for road transport.


                    </p>`,
};
const ComplimentingFleetModernization = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <>
      <ArticleHero
        contentType={data?.contentType}
        title={data?.title}
        createdOn={data?.createdOn}
        imgsrc="/images/about/bg8.webp"
      />
      <div className="bg-dark">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Insights</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#" className="text-capitalize">
                  {data?.contentType}s
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {data?.title}
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <ArticleContainer data={data} />
      <hr className="border-3" style={{ borderColor: "var(--accent-color)" }} />
      <div
                className="stories-section section my-5"
                style={{ maxWidth: "100%" }}
            >
                <div className="container">
                    
                <FlipCardSlider data={relatedBlogs} title={"You may also like"}/>
                </div>
            </div>
    </>
  );
};

export default ComplimentingFleetModernization;
